import { TUXButton } from '@byted-tiktok/tux-components';
import { IconTabArrowCounterClockwiseFill } from '@byted-tiktok/tux-icons';
import React, { FC, useState } from 'react';
import useConfig from 'packages/common/hooks/useConfig';
import { sendLog } from 'packages/common/bridge';
import styles from './index.css';
type StatusProps = {
  icon: React.ReactElement;
  title?: string;
  subtitle?: string;
  isRetry?: boolean;
  darkMode?: boolean;
  errText?: string;
  page?: string;
};

const Status: FC<StatusProps> = ({
  title,
  subtitle,
  icon,
  isRetry,
  darkMode,
  errText,
  page
}) => {
  const {
    t,
    query
  } = useConfig();
  const [loading, setLoading] = useState(false);

  const handleRetry = () => {
    sendLog('load_fail_page_click', {
      page,
      enter_from: query.query
    });
    setLoading(true);
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  return <div className={styles['container']}>
      <div className={styles['content']}>
        <div className="icon mb-20">{icon}</div>
        {title && <div className={`title mb-12 H3-SemiBold text-color-${darkMode ? 'ConstTextInverse' : 'TextPrimary'}`}>
            {title}
          </div>}
        {subtitle && <div className={`subtitle P1-Regular text-color-${darkMode ? 'ConstTextInverse2' : 'TextSecondary'}`}>
            {subtitle}
          </div>}
      </div>
      {isRetry && <div className={styles['action']}>
          <TUXButton text={t('retry_button', 'Retry')} size="large" variant={darkMode ? 'const-secondary' : 'secondary'} icon={<IconTabArrowCounterClockwiseFill />} onClick={handleRetry} isLoading={loading} />
        </div>}
      {errText && <div className={`${styles['err-text']} subtitle P1-Regular text-color-${darkMode ? 'ConstTextInverse2' : 'TextSecondary'}`}>
          {errText}
        </div>}
    </div>;
};

export default Status;